import { Box } from '@mui/system';
import { setHoverArrivalPad } from 'actions/orderActions';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { bindTrigger } from 'material-ui-popup-state';
import React, { SyntheticEvent } from 'react';
import { selectHoverArrivalPad, selectPadStatusMap } from 'selectors/ordersSelector';
import typography from '../../../theme/typography';
import { Order } from '@m4a3/api-client';

import { selectPads } from 'selectors/liveAircraftSelectors';

interface ArrivalPadTagProps {
  popupState: any; 
  destinationPad: number;
  originPad: number | null;
  disabled?: boolean;
  cellId?: number;
}

export const ArrivalPadTag = (props: ArrivalPadTagProps) => {
  const dispatch = useAppDispatch();
  const hoverArrivalPad = useAppSelector(selectHoverArrivalPad);
  const pads = useAppSelector(selectPads);
  const padStatusMap = useAppSelector(selectPadStatusMap);
  
  
  const click = (func: (event: SyntheticEvent<any>) => void) => (
    event: SyntheticEvent<any>
  ) => {
    if (props.disabled) {
      event.preventDefault();
      return;
    }
    func(event);
    event.stopPropagation();
  };
  
  const mouseEnterArrivalPad = () => {
    if (props.disabled || hoverArrivalPad === props.destinationPad) return;
    dispatch(setHoverArrivalPad(String(props.destinationPad)));
  };
  
  const mouseExitArrivalPad = () => {
    if (props.disabled || hoverArrivalPad === null) return;
    dispatch(setHoverArrivalPad(null));
  };
  
  const isArrivalPadHovered =
    !props.disabled && props.destinationPad !== null && props.destinationPad === hoverArrivalPad;

  // Get pad status from memoized selector - much more efficient
  const getPadStatus = (padId: number) => {
    return padStatusMap.get(padId) || { color: null, label: null, count: 0 };
  };

  const getPadNameById = (padId: number): string => {
    if (!padId || padId === null) return '';
    
    // Find the pad with matching ID
    const pad = pads.find(p => p.id == padId);
    if (pad) {
      console.log("ArrivalPadTag - Found pad name:", pad.name, "for ID:", padId);
      return pad.name;
    } else {
      console.log("ArrivalPadTag - No pad found for ID:", padId);
      return padId.toString();
    }
  };

  const getArrivalPadButtonText = (): string => {
    if (!props.destinationPad) {
      return 'Arrival Pad';
    }
    if (props.destinationPad === null) {
      return 'None';
    }
    
    const padName = getPadNameById(props.destinationPad);
    console.log("ArrivalPadTag - Pad name:", padName);
    return padName || props.destinationPad.toString();
  }
  
  const padStatus = getPadStatus(props.destinationPad);
  const statusColor = padStatus.color;

  return (
    <Box
      {...(props.disabled ? {} : bindTrigger(props.popupState))}
      onClick={click(bindTrigger(props.popupState).onClick)}
      pl={0.5}
      ml={1}
      display={'flex'}
      alignItems="center"
      justifyItems="center"
      onMouseEnter={mouseEnterArrivalPad}
      onMouseLeave={mouseExitArrivalPad}
      bgcolor={isArrivalPadHovered ? '#D9DBE9' : props.disabled ? '#F7F7FC' : '#FFFFFF'}
      sx={{
        paddingRight: 1,
        height: 32,
        borderRadius: 1,
        border: `1px ${!props.disabled && props.destinationPad ? 'solid' : 'dashed'} ${
          props.disabled 
            ? '#D9DBE9' 
            : props.destinationPad 
              ? '#14142B' 
              : '#D9DBE9'
        }`,
        opacity: props.disabled ? 0.6 : 1,
        cursor: props.disabled ? 'not-allowed' : 'pointer',
      }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <span className='font-semibold text-nowrap'
          style={{
            ...typography.body2,
            color: props.disabled 
              ? '#A0A3BD' 
              : props.destinationPad 
                ? '#14142B' 
                : 'gray'
          }}
        >
          {getArrivalPadButtonText()}
        </span>
        {!props.disabled && !!props.destinationPad && !!statusColor && (
          <Box
            sx={{
              width: 8,
              height: 8,
              backgroundColor: statusColor,
              borderRadius: '50%',
              border: '1px solid rgba(0,0,0,0.1)',
              flexShrink: 0
            }}
          />
        )}
      </Box>
    </Box>
  );
}; 